export interface FaqItem {
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    question: 'Does this work for my state?',
    answer:
      'Yes. The system is built around the requirements every state shares — ratios, records, health protocols, contracts and reporting — and each volume flags where states commonly differ so you know exactly which line to verify with your own licensor. It is a framework you localize once, not a single state\'s rulebook.',
  },
  {
    question: 'I run a small center, not a home daycare. Is this still for me?',
    answer:
      'It is. Directors of centers under thirty children use the same six volumes; you will lean harder on Volume 3 (staff onboarding and retention) and Volume 5 (rate-setting) than a home provider will, and you can hand The Daily Rhythm straight to your lead teachers.',
  },
  {
    question: 'What format is it? Do I need special software?',
    answer:
      'Six PDF volumes plus five bonus files. They open on any phone, tablet or computer, and every template is built to print cleanly on standard letter paper. No app, no subscription, no login.',
  },
  {
    question: 'How fast can I actually use it?',
    answer:
      'Volume 2 is designed to be usable the same evening you download it. Run the Empty-Seat Calculator, put the Two-Hour Inquiry Rule in place, and use the tour script on your next inquiry. The full read-through takes most providers a week of evenings.',
  },
  {
    question: 'Is this legal advice?',
    answer:
      'No. It is an operating manual written from how licensed programs actually run. The templates are starting points you adapt to your state and, where the stakes warrant it, review with your own attorney or licensing specialist.',
  },
  {
    question: 'I have been doing this for fifteen years. Will I learn anything?',
    answer:
      'Experienced providers usually already know what to do — what they do not have is it written down, consistent, and signed. This is a documentation system more than a teaching course. If your policies live in your head, this is the volume set that gets them onto paper.',
  },
  {
    question: 'Can I share it with my staff or my co-provider?',
    answer:
      'Yes. Your purchase covers your program — print as many copies as your team needs. It is not licensed for reselling, republishing or distributing to other programs.',
  },
  {
    question: 'Why is it only $27?',
    answer:
      'Because a provider deciding between a manual and a week of groceries should not have to decide. Volume matters more to us than margin: the price is low so it reaches the people who need it, not because there is less inside.',
  },
  {
    question: 'What if it is not right for me?',
    answer:
      'Write to [SUPPORT_EMAIL] within seven days and you get every cent back. You keep the files. There is no form to fill out and no reason you need to give.',
  },
];
